exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-category-modal .v--modal-overlay .v--modal-box{width:320px!important;left:50%!important;transfrom:translateX(-50%)}", ""]);

// exports
